import { combineReducers } from 'redux'
import actionList from './action-list'
import buttons from './buttons'
import connection from './connection'
import document from './document'
import buttonActions from './button-actions'
import screen from './screen'
import settings from './settings'
import preset from './preset'
import joyride from './joyride'
import clipboard from './clipboard'
import presetSettings from './preset-settings'

export default combineReducers({
    actionList,
    buttons,
    connection,
    buttonActions,
    document,
    settings,
    screen,
    preset,
    joyride,
    presetSettings,
    clipboard
});